import { createSlice } from '@reduxjs/toolkit';
import { setGlobalErrors } from '../actions';
import { GLOBAL_ERRORS, ErrorGlobal, TYPE_ELEMENT } from '../../../common';

export interface GlobalErrorsState {
  data: ErrorGlobal[] | [];
}

const initialState: GlobalErrorsState = {
  data: [],
};

export const globalErrorsSlice = createSlice({
  name: `${GLOBAL_ERRORS}/${TYPE_ELEMENT}`,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setGlobalErrors, (state, { payload }) => {
      console.log({ payload });
      state.data = [...payload];
    });
  },
});
